import { API_PREFIX, API_APPLET } from '../../config';
import { httpClient } from '../../utils';
import { type ApiResult } from '../apis.d';

// 模拟登录
export const mockLogin = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`/virtual/h5Mini/auth.do`, { params });

// 获取登录信息
export const getLoginContextInfo = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}index/h5/getLoginContextInfo.do`, {
    params,
  });

// 获取当前登录用户公共属性
export const getUserPublicProps = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/applet/sensors/properties`, {
    params,
  });

// 获取账号权限
export const getAccountPermission = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/applet/account/account_check.do`, params, {
    headers: {
      isHideError: true,
    },
  });

// 获取隐私协议信息
export const getPrivacyAgreementInfo = async <U>(params: any): Promise<U> => {
  return await httpClient.get(`${API_PREFIX}api/applet/protocol/getProtocolAuthorizationInfo`, {
    headers: {
      isHideError: true,
    },
  });
};

// 获取企业授权 appId、authCorpId 等参数信息
export const getCorpAuthInfo = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}index/h5/get_auth_info`, params, {
    headers: {
      isHideError: true,
    },
  });

// 根据 corpId 和 userId 查询员工 staffId
export const getUserIdToStaffId = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/staff/briefInfo.do`, params, {
    headers: {
      isHideError: true,
    },
  });

// 获取经理信息
export const getStaffInfo = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/applet/staffCard/detail`, {
    params,
    headers: {
      isHideError: true,
    },
  });

// 获取微信端用户信息
export const getWxUserInfo = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/applet/userinfo/avator`, params, {
    headers: {
      isHideError: true,
    },
  });

// 获取小站背景色配置
export const getStationBgColor = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/applet/station/customize/bgcolor`, params, {
    headers: {
      isHideError: true,
    },
  });

// 获取小站主题配置
export const getStationThemeConfig = async <U>(): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/uiSkin/componentAndParams`, {
    headers: {
      isHideError: true,
    },
  });

// 查询资讯详情
export const getNewsDetail = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/news/detail.do`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
      isHideError: true,
    },
  });
};

// 根据ids资讯列表
export const getNewsList = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/applet/news/basicinfo/list.do`, params);

// 根据分类id查二级分类
export const getSubClassificationList = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/content_library/speech_craft/getListClassifyByOneLevelClassify`, { params });

// 查话术列表
export const getWordsList = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/content_library/speech_craft/getListByTagIdAndClassifyId`, { params });

// 查询 jssdk 签名
export const getTicket = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}index/h5/getTicket.do`, { params });

// 查询问卷基础信息
export const getQuestionnaireInfo = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/questionnaire/get/basic`, { params });
};

// 查询问卷内容信息
export const getQuestionnaireContent = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/questionnaire/get/style/content`, { params });
};

// 查询问卷分享信息
export const getQuestionnaireShare = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/questionnaire/get/style/share`, { params });
};

// 通过模板id获取问卷id
export const getQuestionnaireIdApi = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/questionnaire/get/questionnaireInfoId`, params);
};

// code查话术id
export const getWordsIdByCode = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}formula_pi/api/biz/config/getFormulaPiBizConfigByCondition`, { params });
};

// 查询各应用 agentId
export const getAgentId = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}formula_pi/api/webapp/agentId`, { params });
};

// 以模板ID查询问卷ID
export const queryQuestionnaireInfoId = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/questionnaire/get/questionnaireInfoId`, params);
};

// 节点关怀模板详情
export const getFestivalCareDetail = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/careScene/templates/information`, { params });
};

// 节点关怀获取分享 ID
export const queryFestivalCareShareId = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/careScene/templates/share`, params);
};

// 节点关怀保存草稿
export const saveDraft = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/careScene/draft`, params);
};

// 视频详情
export const queryVideoDetail = async <T, U>(params: T | any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/video/detail`, params);
};

/*
 * 埋点相关
 */

/**
 * @description: 获取快照ID
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const getSnapshotId = async <T, U>(params: T): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/snapshot/save.do`, params);
};

/**
 * @description: 根据快照id查询新闻、产品、早报、小站等详情
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const getDetailBySnapshotId = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/snapshot/detail.do`, params, {
    headers: { isHideError: true },
  });
};

/**
 * @description: 记录客户感兴趣、点联系我等行为
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const recordDynamics = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/dynamics/save.do`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * @description: 新增埋点记录
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const recorderCreate = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/snapshot/recorder/create.do`, params, {
    headers: {
      isHideError: true,
    },
  });
};
/**
 * @description: 埋点记录页面打开时长
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const recordDuration = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/snapshot/recorder/heartbeat.do`, params, {
    headers: {
      isHideError: true,
    },
  });
};

/**
 * @description: 客户经理数据平台一期埋点
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const reportActiveApi = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/staff/report/active`, params, {
    headers: {
      isHideError: true,
    },
  });
};

/**
 * @description: 埋点用户信息
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const submitUserInfoApi = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/bury/submit_user_info.do`, params, {
    headers: {
      isHideError: true,
    },
  });
};

/**
 * @description: 分享链路 - 查看/分享埋点
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const trackBuried = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/tracking/buried`, params, {
    headers: {
      isHideError: true,
    },
  });
};

/**
 * @description: 分享链路 - 获取最新链接上下文信息
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const trackNewcontext = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/tracking/new_context`, params, {
    headers: {
      isHideError: true,
    },
  });
};

/**
 * @description: 光大员工产品页实时埋点
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const recordManagerParam = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/dynamics/ceb/save.do`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/*
 * 基金相关
 */

/**
 * @description: 获取市场行情
 * @param {*}
 * @return {*} MarketListResponse
 */
export const getMarketList = async <T, U>(): Promise<U> => {
  return await httpClient.post(`${API_PREFIX}api/applet/market/list`);
};

/**
 * @description: 获取首发基金
 * @param {*}
 * @return {*} FundNewProductLaunchResponse
 */
export const getNewFund = async <T, U>(): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/fund/new_product_launch`);
};

/*
 * 话题相关
 */

/**
 * @description: 获取话题详情
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const getTopicDetail = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/interactTopic/topics?topicId=${params.topicId}`, {
    headers: {
      isHideError: true,
    },
  });
};
/**
 * @description: 话题正方观点
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const mutationPkStandPositive = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/interactTopic/topics/pkStandPositive`, params);
};

/**
 * @description: 话题反方观点
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const mutationPkStandNegative = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/interactTopic/topics/pkStandNegative`, params);
};

/**
 * @description: 选择类型话题--选择观点
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const mutationOptionalChoice = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/interactTopic/topics/optionalChoice`, params);
};

/**
 * @description: 话题评论点赞
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const commentLike = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/interactTopic/topics/commentLike`, params);
};

/*
 * 话题埋点
 */
/**
 * @description: 访问话题页面
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const topicView = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/interactTopic/topics/view`, params);
};

/*
 * 产品相关
 */
/**
 * @description: 获取业务关联的产品
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const getelateProductList = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}relate/product/v3/list`, { params });
};

/**
 * @description: 编辑关联产品
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const mutationRelateProductUpdate = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}relate/product/update`, params);
};

/**
 *  素材分享埋点
 * @param params
 * @returns
 */
export const sharePoster = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/poster/share_poster`, params);
};

/**
 * 海报长链接转短链接
 * @returns
 */
export const getShortLinkFromLong = async (
  params: any
): Promise<
  ApiResult<{
    shortUrl: string;
  }>
> => {
  return await httpClient.post(`${API_PREFIX}create`, params);
};

/*
 * @description: 获取当前系统时间接口
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const getCurrentSystemTimeApi = async <T, U>(params: T): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/sop/snapshot/current_time`, { headers: { isHideError: true }, params });
};

/**
 * @description: 获取产品详情自定义分享配置数据
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const getProductShareConfigApi = async <T, U>(params: T): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/share/getConfig.do`, params, {
    headers: { isHideError: true },
  });
};

/**
 * @description: 获取小站名称
 * @param {*} U
 * @return {*}
 */
export const getStationNameApi = async <U>(): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/station/getStationName`);
};

/**
 * 根据零碎数据主键key和企业id判断企业是否在白名单配置中
 */
export const getKeyIsInWhiteList = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/scrapData/isInWhiteList.do`, {
    params,
  });
};

/*
 * @description: 微信临时素材至服务器换取url
 * @param {*} U
 * @return {*}
 */
export const getImageUrlByMediaId = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_APPLET}cmt/customer/common/upload`, params, {
    headers: {
      isHideError: true,
      'Content-Type': 'multipart/form-data',
    },
  });
/**
 * @description: 长链转短链
 */
export const changeLongLinkToShortApi = async <T, U>(params: T): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}create`, params, {
    headers: { isHideError: true },
  });
};

/**
 * @description: 获取配置了营销机会应用的公司ID列表
 * @param {*} T
 * @param {*} U
 * @return {*}
 */
export const getValidCorpListApi = async <T, U>(): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/sop/snapshot/valid_corp_list`, { headers: { isHideError: true } });
};

/**
 * @description: 气泡标签群发标记客户
 */
export const addMarkCustomerTag = async <T, U>(params: T): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/bubble/add_mark_customer_tag`, params, {});
};

/**
 * @description: 摘除标记客户的标签
 */
export const removeMarkTag = async <T, U>(params: T): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/bubble/remove_mark_tag`, params, {});
};

// 名片开关切换
export const updateCardShow = async <T, U>(params: T): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/staffCard/update_show_flag`, params, {
    headers: { isHideError: true },
  });
};

/**
 * @description: 获取最新早报数据
 * @param {*} U
 * @return {*}
 */
export const getLatestNewspaperOfMorning = async <U>(): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/morningPaper/papers/latest`, {
    headers: { isHideError: true },
  });
};

/**
 * @description: 获取最新晚报数据
 * @param {*} U
 * @return {*}
 */
export const getLatestNewspaperOfEvening = async <U>(): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/finance/evening_paper/find_last_evening_paper`, {
    headers: { isHideError: true },
  });
};

export const getInEffectedList = async <T, U>(): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}bizconfig/corp/home-menu/getInEffected`);
};

/**
 * 文件上传
 */
export const uploadFile = async (params: { file: any; bizKey: string; staffId: string }): Promise<ApiResult<any>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/file/upload.do`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// 获取路由白名单
export const queryVuePagePaths = async <T, U>(params): Promise<ApiResult<U>> => {
  return await httpClient.get(`/caizhi-entry/api/vue-white-path-config`, { params });
};

// 是否新版雷达白名单
export const hitRadarWhiteList = async <T, U>(): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/data/dynamic/hitRadarWhiteList`, {
    headers: {
      isHideError: true,
    },
  });

// 获取弹窗信息
export const getPopupInfoApi = async <U>(params: {
  staffId: string;
  pushLocation: '1' | '2'; // 1:工作室/小站   2:早报
}): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/popup/view`, params, {
    headers: { isHideError: true },
  });
};

export const uploadFileMediaId = async (params: { mediaId: any }): Promise<ApiResult<any>> => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(params)) {
    formData.append(key, value as string | Blob);
  }
  const data = formData;
  return await httpClient.post(`${API_PREFIX}api/applet/staffCard/upload`, data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};
